<template>
  <div id="app">
    <Navigation v-if="authenticated" />

    <transition name="fade" mode="out-in">
      <router-view class="section" />
    </transition>

    <b-loading
      :is-full-page="true"
      :active.sync="loading"
      :can-cancel="false"
    ></b-loading>
  </div>
</template>

<script>
import Navigation from '@/components/Navigation'
import {mapGetters} from 'vuex'
export default {
  components: {
    Navigation,
  },
  name: 'App',
  computed: {
    ...mapGetters({
      loading: 'loading',
      authenticated: 'authenticated',
    }),
  },
}
</script>
